// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Restore bootstrap heading margins because our stylesheet is :shit: */
.KxW7dPY40mRZCFO1tR4O h1,
.KxW7dPY40mRZCFO1tR4O h2,
.KxW7dPY40mRZCFO1tR4O h3 {
  margin-top: 20px;
  margin-bottom: 10px;
}

.KxW7dPY40mRZCFO1tR4O h4,
.KxW7dPY40mRZCFO1tR4O h5,
.KxW7dPY40mRZCFO1tR4O h6 {
  margin-top: 10px;
  margin-bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./../../graylog2-server/graylog2-web-interface/src/views/pages/StyleFixups.css"],"names":[],"mappings":"AAAA,uEAAuE;AACvE;;;EAGE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["/* Restore bootstrap heading margins because our stylesheet is :shit: */\n:local(.bootstrapHeading) h1,\n:local(.bootstrapHeading) h2,\n:local(.bootstrapHeading) h3 {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\n:local(.bootstrapHeading) h4,\n:local(.bootstrapHeading) h5,\n:local(.bootstrapHeading) h6 {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bootstrapHeading": `KxW7dPY40mRZCFO1tR4O`
};
export default ___CSS_LOADER_EXPORT___;
